module.exports = __webpack_public_path__ + "static/media/Fumigation.53299694.png";